<meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />

    <div class="modal-header">
    </div>
    <div class="modal-body" #scrollDiv>
        <form name="comment-modal-form" (submit)="redirectToLogin()" #sessionModal="ngForm">
            <div class="form-group">
                <div slot="body" class="body">
                    <div class="content">
                        <div class="inner">
                            <div class="clock">
                                <img src="assets/images/art_sessionexpired.svg" class="clock-img" alt="Session expired" />
                            </div>
                            <div class="session-header">
                                {{ 'Session.SessionExpired' | translate }}
                            </div>
                            <div class="session-message">
                                {{ 'Session.SessionInactivity' | translate }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
    <div class="modal-footer form-group footer">
        <wdpr-button class="d-flex bottom" theme="primary" (click)="redirectToLogin()">
            {{ 'Session.LogIn' | translate }}
        </wdpr-button>
    </div>

